import { deriveStorageHealthLevel } from "@/lib/storageHealthLevel"
import type { StorageHealthService, StorageStatus } from "../types"

export const storageHealth: StorageHealthService = {
  async requestPersistence() {
    if (!navigator.storage?.persist) return null
    try {
      // Avoid re-prompting a user who already granted this in an earlier
      // session — persisted() is a plain read, persist() may prompt.
      if (await navigator.storage.persisted?.()) return true
      return await navigator.storage.persist()
    } catch {
      return null
    }
  },

  async getStatus(): Promise<StorageStatus> {
    if (!navigator.storage?.estimate) {
      return { usage: null, quota: null, deviceFree: null, level: "ok" }
    }
    try {
      const { usage, quota } = await navigator.storage.estimate()
      const status = {
        usage: usage ?? null,
        quota: quota ?? null,
        // Not exposed to the browser — a full device can still evict a
        // well-under-quota origin, but there's no API to see it coming.
        deviceFree: null,
      }
      return { ...status, level: deriveStorageHealthLevel(status) }
    } catch {
      return { usage: null, quota: null, deviceFree: null, level: "ok" }
    }
  },
}
